module.exports = __webpack_public_path__ + "static/media/Soleil-Regular.418b6c2f.otf";